import axios from 'axios';
import { toast } from 'react-toastify';

const API_BASE_URL = process.env.REACT_APP_API || 'https://api.vidal-app.com';

// ── Modo demonstração (somente-leitura) ──
function isDemoMode() {
  try { return localStorage.getItem('vidal_demo_mode') === 'true'; } catch { return false; }
}

function shouldSimulate(config = {}) {
  if (!isDemoMode()) return false;
  const method = (config.method || 'get').toLowerCase();
  if (method === 'get' || method === 'head') return false;
  const url = config.url || '';
  if (/(search|count|stats|kpis|aggregat|export|relatorio|report)/i.test(url)) return false;
  // Rotas de autenticação nunca são simuladas (login/register/etc.)
  if (/\/auth\//i.test(url)) return false;
  return true;
}

let lastDemoToast = 0;
function notifyDemoSimulated() {
  const nowTs = Date.now();
  if (nowTs - lastDemoToast > 1500) {
    lastDemoToast = nowTs;
    toast.info('Modo demonstração: alterações não são salvas.', { toastId: 'demo-readonly' });
  }
}

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    // Em modo demo, simula mutações: resolve com sucesso sintético sem chamar o backend
    if (shouldSimulate(config)) {
      notifyDemoSimulated();
      config.adapter = () => Promise.resolve({
        data: { success: true, simulated: true, demo: true },
        status: 200,
        statusText: 'OK (demo)',
        headers: {},
        config,
      });
    }

    const authData = JSON.parse(localStorage.getItem('vidal_auth') || '{}');
    const token = authData.token;
    const userId = authData.userId;
    const projeto = localStorage.getItem('vidal_selected_project');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (userId) {
      config.headers.user = userId;
    }

    if (projeto && !config.headers.projeto) {
      config.headers.projeto = projeto;
    }

    const simulatedUserId = localStorage.getItem('simulatedUserId');
    if (simulatedUserId) {
      config.headers['x-simulated-user'] = simulatedUserId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    const newToken = response.headers.authorization;
    if (newToken) {
      const authData = JSON.parse(localStorage.getItem('vidal_auth') || '{}');
      const token = newToken.replace('Bearer ', '');
      localStorage.setItem('vidal_auth', JSON.stringify({ ...authData, token }));
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('vidal_auth');
      localStorage.removeItem('vidal_user');
      localStorage.removeItem('vidal_selected_project');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
